import { EXTRA_BOTTOM_ROWS } from '@bringg-frontend/monitoring-shared';

export const getRowsCountWithBottomExtraSpace = (rowCount: number) => (rowCount ? rowCount + EXTRA_BOTTOM_ROWS : 0);
